module.exports = {
  messages: {
    CN: {
      header: {
        allProduct: "商品分类",
        searchPlaceholder: "请输入搜索内容",
        accountOrder: "我的订单",
        accountCollect: "我的收藏",
        accountIntegral: "我的积分",
        accountCoupon: "我的优惠券",
        logout: "退出登录",
        hotRecommend: '热门推荐',
        searchHistory: '搜索记录',
        empty: '清空',
        more: '更多'
      }
    },
    JP: {
      header: {
        allProduct: "商品分类",
        searchPlaceholder: "検索内容を入力してください",
        accountOrder: "我的订单",
        accountCollect: "我的收藏",
        accountIntegral: "我的积分",
        accountCoupon: "我的优惠券",
        logout: "ログアウト",
        hotRecommend: '热门推荐',
        searchHistory: '検索履歴',
        empty: 'クリア',
        more: 'もっと'
      }
    }
  }
};